customElements.define("quick-add", class QuickAdd extends HTMLElement{
    constructor(){
        super();

        this.quickAddWrapper = this.querySelector('.quick-add');
        this.toggleQuickAddBtn = this.querySelector('.js-toggle-quick-add');
        this.atcBtns = this.querySelectorAll('.js-add-quick-add-variant');
        this.cardWrapper = this.closest('.grid__item, .total-look-product-item');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        //Close on exit grid item
        if (this.cardWrapper) {
            this.cardWrapper.addEventListener("mouseleave", this.closeQuickAdd.bind(this));
            this.cardWrapper.addEventListener("mouseenter", this.showQuickAdd.bind(this));
        }

        //Add to cart that variant
        if (this.atcBtns && this.atcBtns.length > 0) {
            this.atcBtns.forEach(btn=>btn.addEventListener("click", this.addToCart.bind(this)));
        }

        //Show quick add btns if on mobile
        if(window.innerWidth<768 && this.toggleQuickAddBtn){
            this.toggleQuickAddBtn.classList.remove("hidden");
            document.addEventListener("click", (e)=>{
                if(!e.target.closest('quick-add')){
                    this.closeQuickAdd();
                }
            });
        }
    }

    showQuickAdd(){
        this.classList.remove("hidden");
        if(this.toggleQuickAddBtn) {
            this.toggleQuickAddBtn.classList.add("hidden");
        }
    }

    closeQuickAdd(){
        if(this.quickAddWrapper){
            this.classList.add("hidden");
            if(this.toggleQuickAddBtn) {
                this.toggleQuickAddBtn.classList.remove("hidden");
            }
        }
    }

    addToCart(e){
        const clickedBtn = e.target;
        const variantId = clickedBtn.dataset.variantId;
        console.log("Hola", variantId);

        const data = {
            items: [
                {
                    id: variantId,
                    quantity: 1
                }
            ]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js?sections=cart-drawer,cart-icon-bubble', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            return response.json();
          })
        .then(response=>{
            this.cart.renderContents(response);
        })
        .catch((error) => {
        console.error('Error:', error);
        })
        .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        });
    }
});